module.exports = __webpack_public_path__ + "img/product_114.8939a6c.webp";